import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useReviewShowContext } from 'modules/reviews/pages/performance/Show/hooks'

const NavigateToReviewIndexPage = () => {
  const { navigation } = useNavigation()

  const { canEditReview, review } = useReviewShowContext()

  const id = Number(review.id)
  const configurationPath = navigation.performance.reviews.id.configuration.fullPath({
    id,
  })
  const reviewsPath = navigation.performance.reviews.id.reviews.fullPath({ id })

  return <Navigate replace to={canEditReview ? configurationPath : reviewsPath} />
}

export default NavigateToReviewIndexPage
